import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateOperatorSignInOutReason = async ({
  operatorId,
  slackId,
  reason,
}: {
  operatorId?: string;
  slackId?: string;
  reason: string;
}) => {
  const response = await mutationExecute({
    variables: {
      operatorId,
      slackId,
      reason,
    },
    mutation: graphql(`
      mutation UpdateOperatorSignInOutReason($operatorId: String, $slackId: String, $reason: String!) {
        updateOperatorSignInOutReason(operatorId: $operatorId, slackId: $slackId, reason: $reason) {
          id
        }
      }
    `),
  });

  return response.data?.updateOperatorSignInOutReason;
};
